module.exports = __webpack_public_path__ + "assets/arrow.faf3501b.svg";